/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useDynamicThrottledUpdates2} from "../../CoverageRequirements/ItemDetails/CoverageRequirementsStudyDetails";
import useGetHubName from "../../../components/Socket/useGetHubName";
import {useAppDispatch} from "../../../../redux/hooks";
import useSocket from "../../../components/Socket/useSocket";
import {memo, useCallback} from "react";
import {
  CoverageRequirementsRedlineTreeDbItemUpdateActionType,
} from "../../../../redux/ducks/CoverageRequirements/slice";
import {handleExecutionStatusUpdate, handleMergedExecutionStatusUpdate} from "../../CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/LeftPanelComponents/LeftPanelCoverageRequirements";

const StudySockets = memo(({ studyIds }: {studyIds: string[]}) => {
  return (
    <div>
      {studyIds.map(studyId => (
        <StudySocket key={studyId} studyId={studyId} />
      ))}
    </div>
  );
})

const StudySocket = memo(({ studyId }: {studyId: string}) => {
  const dispatch = useAppDispatch();

  const onMessage = useDynamicThrottledUpdates2(dispatch, 3000, 5000);
  const hubName = useGetHubName(`redlineRunProgress_${studyId}`);
  useSocket(hubName, onMessage);

  const onMessageTreeSocket = useCallback((msg: any) => {
    const data = msg.data
    const type = msg.type

    const selectedDatasetId = data?.datasetId
    if (!selectedDatasetId || !data) {
      return
    }

    switch (type) {
      case CoverageRequirementsRedlineTreeDbItemUpdateActionType.ExecutionStatusUpdate:
        handleExecutionStatusUpdate(data, selectedDatasetId, dispatch)
        break
      case CoverageRequirementsRedlineTreeDbItemUpdateActionType.MergedTreeExecutionStatusUpdate:
        handleMergedExecutionStatusUpdate(data, selectedDatasetId, dispatch)
        break
      default:
        break
    }
  }, [])
  const hubNameTreeSocket = useGetHubName(`coverageRequirementsTree_${studyId}`)
  useSocket(hubNameTreeSocket, onMessageTreeSocket)

  // Render nothing, as this component is only for setting up the socket
  return null;
})



export default StudySockets

